module.exports = __webpack_public_path__ + "static/img/ip-right.f51085d4.png";